import { Expose, Type } from 'class-transformer';

class VehicleDepotEntryResult {
  @Expose()
  yoldakiAracSayisi!: number;

  @Expose()
  siradakiAracSayisi!: number;

  @Expose()
  iceridekiAracSayisi!: number;

  @Expose()
  aktarmaAracSayisi!: number;
}

export class IVehicleDepotEntryResponse {
  @Expose()
  status!: string;

  @Expose()
  message!: string;

  @Expose()
  @Type(() => VehicleDepotEntryResult)
  result!: VehicleDepotEntryResult;
}
